/**
 * Service to get common strings from /content/localization/strings/common
 */
import storage from './storage.js';
import events from './event.js';
import ConfigService from './configurationService.js';

/**
 *
 * StringService
 *
 * @namespace StringService
 */
var StringService = function() {
    "use strict";

    var STRINGS_STORAGE_KEY = 'shop-strings-';
    var EXPIRE_TIME = 1000 * 60 * 20;   // 20 minutes

    var publicMethods = {
        /**
         * Gets a string value for the requested string
         *
         * @param stringCd - key for the string to get
         * @param locale - locale of the string
         * @param dfltStr - if not found, the string to return
         * @param callbackFn
         */
        getString: function(stringCd, locale, dfltStr, callbackFn) {
            loadStrings(locale, stringCallbackFn(stringCd, dfltStr, callbackFn));
        },

        /**
         * Gets string values for a list of requested strings
         *
         * @param stringInfos - [{key: value, dflt:value},{key:value, dflt:value}...]
         * @param locale - locale of the string
         * @param callbackFn
         */
        getStrings: function(stringInfos, locale, callbackFn) {
            if (callbackFn) {
                loadStrings(locale, stringsCallbackFn(stringInfos, callbackFn));
            } else {
                // asynchronous check for valid strings
                var strings = loadStoredStrings(locale);
                if (strings && (Date.now() - strings.timestamp <= EXPIRE_TIME)) {
                    return getRequestedStrings(strings, stringInfos);
                }
                return null;
            }
        },

        /**
         * Helper function to get the PSV label.  Can be different based on account type.
         *
         * @param accountType
         * @param locale
         * @param callbackFn
         */
        getPsvString: function(accountType, locale, callbackFn) {
            switch (accountType) {
                case "10" :
                    this.getString('psvDist', locale, 'PSV', callbackFn);
                    break;
                case "20" :
                    this.getString('psvCust', locale, 'Product Value', callbackFn);
                    break;
                case "30" :
                    this.getString('psvPfc', locale, 'PSV', callbackFn);
                    break;
                default:
                    this.getString('psvAnon', locale, 'Product Value', callbackFn);
                    break;
            }
        }
    };

    function stringCallbackFn(_stringCd, _dfltStr, _callbackFn) {
        var stringCd = _stringCd,
            dfltStr = _dfltStr,
            callbackFn = _callbackFn;

        return function(strings) {
            var returnStr = dfltStr;

            if (strings[stringCd]) {
                returnStr = strings[stringCd];
            }
            callbackFn(returnStr);
        }
    }

    function stringsCallbackFn(_stringInfos, _callbackFn) {
        var stringInfos = _stringInfos,
            callbackFn = _callbackFn;

        return function(strings) {
            callbackFn(getRequestedStrings(strings, stringInfos));
        }
    }

    function getRequestedStrings(strings, stringInfos) {
        var returnVal = {},
            key;

        for (var i = 0; i < stringInfos.length; i++) {
            key = stringInfos[i].key;
            if (strings[key]) {
                returnVal[key] = strings[key];
            } else {
                returnVal[key] = stringInfos[i].dflt;
            }
        }
        return returnVal;
    }

    function loadStrings(locale, stringsCallbackFn) {
        var strings = loadStoredStrings(locale);

        if (!strings || (strings.timestamp && ((Date.now() - strings.timestamp) > EXPIRE_TIME))) {
            loadServerStrings(locale, stringsCallbackFn);
        } else {
            // to imitate an async ajax call.  Angular app calls $scope.$apply()
            setTimeout(function() {
                stringsCallbackFn(strings);
            }, 1);
        }
    }

    function loadStoredStrings(locale) {
        var strings = null;
        if (storage){
            strings = storage.getItem(STRINGS_STORAGE_KEY + locale);
            events.publish(events.global.STRINGS_SERVICES_LOADED, strings);
        }
        return strings;
    }

    function saveServerStrings(strings, locale) {
        if (storage) {
            if (strings) {
                storage.setItem(STRINGS_STORAGE_KEY + locale, strings);
            } else {
                storage.setItem(STRINGS_STORAGE_KEY + locale, null);
            }
        }
    }

    function loadServerStrings(locale, _stringsCallbackFn) {
        var stringsCallbackFn = _stringsCallbackFn,
            url = ConfigService.getMarketConfig().nsurl_commonStrings.replace('{locale}', locale);

        $.ajax({
            type: "GET",
            url: url,
            success: function(strings) {
                if(strings)strings.timestamp = Date.now();
                saveServerStrings(strings, locale);
                stringsCallbackFn(strings);
                events.publish(events.global.STRINGS_SERVICES_LOADED, strings);
            },
            error: function REPLACE(err) {
                console.log('Common strings could not be loaded.');
                events.publishAjaxErrorEvent(events.errors.STRING_SERVICE, url, err);
                stringsCallbackFn({});
            }
        });

    }

    return publicMethods;
}();

export default StringService;



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/stringService.js
// module id = 295
// module chunks = 0